Deletes an empty position opening.

Each position profile that belongs to a position opening must be deleted before the position opening can be deleted.
